import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Select, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';
import { t } from '../../i18n';

export const CancellationReasonCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/cancellation-reasons',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title={t('cancelReasons.new')}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="O'zbekcha"
                  help="Bekor qilish sababining o'zbek tilidagi versiyasi"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('common.reason')}
                    help="Bekor qilish sababining o'zbek tilidagi matni"
                  />
                }
                name="reasonUz"
                rules={[{ required: true, message: 'Sababni kiriting' }]}
              >
                <Input placeholder="Haydovchi uzoq kutildi" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="Ruscha"
                  help="Bekor qilish sababining rus tilidagi versiyasi"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('common.reason')}
                    help="Sababning ruscha tarjimasi"
                  />
                }
                name="reasonRu"
                rules={[{ required: true, message: 'Sababni kiriting' }]}
              >
                <Input placeholder="Долго ждал водителя" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="Inglizcha"
                  help="Bekor qilish sababining ingliz tilidagi versiyasi"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('common.reason')}
                    help="Sababning inglizcha tarjimasi"
                  />
                }
                name="reasonEn"
                rules={[{ required: true, message: 'Sababni kiriting' }]}
              >
                <Input placeholder="Waited too long for driver" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24}>
            <Card
              title={
                <SectionTitle
                  title="Qo'shimcha sozlamalar"
                  help="Sabab turi va tartib raqami"
                />
              }
            >
              <Row gutter={16}>
                <Col xs={24} md={6}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('cancelReasons.type')}
                        help="Sabab kimga tegishli: Mijoz yoki Haydovchi"
                      />
                    }
                    name="actorType"
                    rules={[{ required: true, message: 'Turini tanlang' }]}
                  >
                    <Select placeholder="Tanlang">
                      <Select.Option value="CLIENT">Mijoz</Select.Option>
                      <Select.Option value="DRIVER">Haydovchi</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('faq.sortOrder')}
                        help="Sabab qaysi tartibda ko'rinadi. Kichik raqamlar yuqorida."
                      />
                    }
                    name="sortOrder"
                    initialValue={0}
                  >
                    <InputNumber min={0} placeholder="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('common.active')}
                        help="Sabab foydalanuvchilarga ko'rinadimi"
                      />
                    }
                    name="isActive"
                    valuePropName="checked"
                    initialValue={true}
                  >
                    <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
